module.exports = __webpack_public_path__ + "static/AssessmentCenter-d9ce7295ae345edd0132406ea7e0162e.png";